function CloseIconSmall({ size = '12', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.10103 10.1919C0.905773 10.3872 0.905773 10.7038 1.10103 10.899C1.2963 11.0943 1.61288 11.0943 1.80814 10.899L6.00004 6.70715L10.1919 10.8991C10.3872 11.0943 10.7038 11.0943 10.8991 10.8991C11.0943 10.7038 11.0943 10.3872 10.8991 10.192L6.70715 6.00005L10.8991 1.80814C11.0943 1.61288 11.0943 1.2963 10.8991 1.10104C10.7038 0.905776 10.3872 0.905776 10.1919 1.10104L6.00004 5.29294L1.80814 1.10104C1.61288 0.905782 1.2963 0.905782 1.10104 1.10104C0.905774 1.29631 0.905774 1.61289 1.10104 1.80815L5.29293 6.00005L1.10103 10.1919Z"
        fill="#20293C"
      />
    </svg>
  );
}

export default CloseIconSmall;
